/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';

import { flexProps } from '../flex';
import Element from './element/element';
import css from './elements.css';

export default function Elements(props) {
  const { absolute, parentId, selectElementsByParentId, ...filters } = props;

  const selectedElements = selectElementsByParentId(parentId, filters);
  if (!selectedElements.length) return null;

  const objectStyles = pick(props.styles, flexProps);

  return (
    <div css={css({ absolute, objectStyles })}>
      {selectedElements.map((element) => (
        <Element {...props} data={element} Elements={Elements} key={element.id} />
      ))}
    </div>
  );
}

Elements.propTypes = {
  absolute: PropTypes.bool,
  styles: PropTypes.shape().isRequired,
  parentId: PropTypes.string.isRequired,
  selectElementsByParentId: PropTypes.func.isRequired,
  omitHidden: PropTypes.bool,
};

Elements.defaultProps = {
  omitHidden: false,
  absolute: false,
};
